import { Handlebars } from 'gridstrap/lib/gs-handlebars';

export class GSTemplateService {
	private templates = {};

	set(id, template) {
		this.templates[id] = Handlebars.compile(this.parse(template));
	}

	render(id, data) {
		let template = this.templates[id];
		return template && template(data);
	}

	private parse(template) {
		return template
			.replace(/«/g, '{{')
			.replace(/»/g, '}}');
	}
}
